import { Component, Inject, OnInit } from '@angular/core';
import { FileReaderEvent } from '../../GET_NEW_UI/setup-implement/setup-implement.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-attach-file-dialog',
  templateUrl: './attach-file-dialog.component.html',
  styleUrls: ['./attach-file-dialog.component.scss']
})
export class AttachFileDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AttachFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    NewFileName: string = "";
    FilePreview: string = "";
  Extension: string = ""
  acceptedTypes: string = "application/msword,text/plain,application/pdf,application/vnd.ms-excel";
  ngOnInit() {
    console.log("this.data:", this.data);
    if (this.data != null) {
      if (this.data.acceptedTypes != null && this.data.acceptedTypes != "")
        this.acceptedTypes = this.data.acceptedTypes;
    }
  }

  onFileChanged(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
  
      reader.readAsDataURL(event.target.files[0]); // read file as data url
  
  //console.log("event.target.files[0]",event.target.files[0])
      this.NewFileName = event.target.files[0].name
      this.Extension = event.target.files[0].name.split('.').pop().toLowerCase(),
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        var fileUrl = (event.target["result"]);
        this.FilePreview = fileUrl.toString();
        
      }
    }
  }

  submitFilePreview(){
    
    let obj = {
         
      FilePreview: this.FilePreview,
      NewFileName: this.NewFileName,    
      Extension:this.Extension
    }
   
    this.dialogRef.close(obj)
  }
  DialogClose(){
    this.dialogRef.close(false)
  }

}
